import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=f8c1800c&scoped=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"
import style0 from "./Service.vue?vue&type=style&index=0&id=f8c1800c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c1800c",
  null
  
)

export default component.exports